import { isArray, isPlainObject } from 'lodash';

export const trimGraphqlType = <TModel>(model: TModel): TModel & { __typename?: never } => {
  if (model === undefined || model === null) {
    return model as TModel & { __typename?: never };
  }
  if (!isPlainObject(model) && !isArray(model)) {
    // don't trim if not an object or array.
    return model;
  }
  const { __typename, ...data } = model as TModel & { __typename?: string };
  let result;
  if (isArray(model)) {
    result = model.map(trimGraphqlType);
  } else {
    result = {} as any;
    for (const key in data) {
      const value = data[key as keyof typeof data];
      if (isPlainObject(value)) {
        result[key] = trimGraphqlType(value);
      } else if (isArray(value)) {
        result[key] = value.map(trimGraphqlType);
      } else {
        result[key] = value;
      }
    }
  }

  return result;
};
